import { Announced } from '@fluentui/react';
import { useTranslation } from 'react-i18next';

export interface IPickerErrorBarAnnouncement {
  /** Announce if the duration between start and end date is more than one year. */
  isMoreThanOneYear: boolean | undefined;
  /** Announce if the start date is before the end date. */
  isEndBeforeStart: boolean | undefined;
  /** Announce if any of the selected dates are in the future. */
  isAnyDateAfterToday: boolean | undefined;
}

/** Announces error messages to screen readers for the `PickerErrorBar` component. */
export const PickerErrorBarAnnouncement = ({
  isMoreThanOneYear,
  isEndBeforeStart,
  isAnyDateAfterToday,
}: IPickerErrorBarAnnouncement) => {
  const [t] = useTranslation(['search', 'translation']);
  const message = [
    isMoreThanOneYear &&
      t(
        'errorDateNotBetweenOneYear',
        'Duration between start and end date should be within a year.'
      ),
    isEndBeforeStart &&
      t('errorDatesBackwards', 'Start date is before end date'),
    isAnyDateAfterToday &&
      t('errorFutureDate', 'You selected a date that is in the future'),
  ]
    .filter(Boolean)
    .join(' ');
  return <Announced message={message} />;
};
